import type { IdentityStatus } from '@/hooks/useIdentityVerification'

/** How a patient's identity status reads on the chart card and the identity task panel. */
export const IDENTITY_STATUS_LABELS: Record<IdentityStatus, string> = {
  not_started: 'Not started',
  pending: 'Pending',
  review_required: 'Review required',
  verified_auto: 'Verified automatically',
  verified_manual: 'Verified manually',
  rejected: 'Rejected',
}

export const STATUS_CHIP_CLASSES: Record<IdentityStatus, string> = {
  not_started: 'border-slate-200 bg-slate-50 text-slate-600',
  pending: 'border-blue-100 bg-blue-50 text-blue-700',
  review_required: 'border-amber-200 bg-amber-50 text-amber-800',
  verified_auto: 'border-green-200 bg-green-50 text-green-700',
  verified_manual: 'border-green-200 bg-green-50 text-green-700',
  rejected: 'border-red-200 bg-red-50 text-red-700',
}
